
/**
 * @desc axios 请求封装
 * @author zhangy 2019.07.30
 */

import { hostname } from './config'
import axios from 'axios'
// import { Message } from 'element-ui'

// axios 配置
axios.defaults.timeout = 100000
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.baseURL = process.env.BASE_API_URL

/**
 * @desc 统一请求方法封装
 * @param {*} url
 * @param {*} data 数据
 * @param {*} method 请求方案
 */
export const request = ({ url, data, method = 'POST', success, fail }) => {
  // 数据处理
  if (!url) {
    console.log('请求地址错误', url)
    return false
  }
  // host
  if (url.indexOf('http:') < 0 && url.indexOf('https:') < 0) {
    url = hostname + url
  }
  // GET 请求特殊处理
  if (method === 'GET') {
    if (typeof data === 'object') {
      const arr = Object.keys(data)
      for (let i = 0, len = arr.length; i < len; i++) {
        if (url.indexOf('?') < 0) {
          url += '?'
        }
        if (i === 0) {
          url += `${arr[i]}=${data[arr[i]]}`
        } else {
          url += `&${arr[i]}=${data[arr[i]]}`
        }
      }
    }
  }
  try {
    // 相关方法
    return axios({
      method,
      url,
      data,
      withCredentials: true
    }).then(function (res) {
      // console.log(res, 'axios');
      // 接口200
      if (res && res.status === 200) {
        const _data = res.data
        // 请求数据
        if (_data && _data.code === 200) {
          typeof success === 'function' && success(_data.data)
        } else {
          // msg提醒，_data.msg
          console.log(_data.msg, '_data.msg')
          // if (_data && _data.code !== 209) {
          //   // 手机号未被占用
          //   Message({
          //     message: _data.msg || 'Error',
          //     type: 'error',
          //     duration: 5 * 1000
          //   })
          //   if (_data.code === 211 || _data.code === 210 || _data.code === 206 || _data.code === 207) {
          //     // 用户未登录或不存在 用户登录失败
          //     setTimeout(() => {
          //       if (process.client) {
          //         window.location.href = '/login'
          //       }
          //     }, 1000)
          //   }
          // }
          typeof fail === 'function' && fail(_data)
        }
      } else {
        typeof fail === 'function' && fail(res)
      }
    })
  } catch (err) {
    console.log(err, 'api error')
  }
}
